import { MapStyle } from '../CustomMap';

export const DEFAULT_ZOOM_TO_LOCATION_LEVEL = 6;

export const MAX_AUTO_ZOOM_LEVEL = 16;

/**
 * Maximum animation time in seconds
 * Will skip the animation if the time is greater than this value
 * */
export const MAX_FOCUS_ANIMATION_TIME = 5_000;

export const MAP_STYLES: Record<MapStyle, string> = {
  default: 'mapbox://styles/seedtrace/clia0bhp5004l01pghikh13gg',
  satellite: 'mapbox://styles/seedtrace/clon0fll500bi01nzfrjgfbs9',
  outdoors: 'mapbox://styles/seedtrace/clxbr71kg02ah01pn1izlaoxp',
};

/**
 * Default mapbox style
 * MapboxDrawOptions.styles is an array of objects
 * @see https://docs.mapbox.com/api/navigation/styles/
 */
export const DRAW_CONTROL_STYLES: object[] = [
  // single point active build with two circles (inner & outer)
  {
    id: 'gl-draw-point-active-outer',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['==', 'active', 'true']],
    paint: {
      'circle-radius': 15,
      'circle-color': '#F6A92D',
      'circle-opacity': 0.4,
    },
  },
  {
    id: 'gl-draw-point-active-inner',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['==', 'active', 'true']],
    paint: {
      'circle-radius': 7,
      'circle-color': '#F6A92D',
    },
  },
  // single  point inactive build with two circles (inner & outer)
  {
    id: 'gl-draw-point-inactive-outer',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['==', 'active', 'false']],
    paint: {
      'circle-radius': 15,
      'circle-color': '#5FB0CD',
      'circle-opacity': 0.4,
    },
  },
  {
    id: 'gl-draw-point-inactive-inner',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['==', 'active', 'false']],
    paint: {
      'circle-radius': 7,
      'circle-color': '#62D6EF',
    },
  },
  // polygon fill active
  {
    id: 'gl-draw-polygon-fill-active',
    type: 'fill',
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'true']],
    paint: {
      'fill-color': '#F6A92D',
      'fill-outline-color': '#F6A92D',
      'fill-opacity': 0.2,
    },
  },
  // polygon fill inactive
  {
    id: 'gl-draw-polygon-fill-inactive',
    type: 'fill',
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'false']],
    paint: {
      'fill-color': '#62D6EF',
      'fill-outline-color': '#62D6EF',
      'fill-opacity': 0.2,
    },
  },
  // polygon mid points
  {
    id: 'gl-draw-polygon-midpoint',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
    paint: {
      'circle-radius': 3,
      'circle-color': '#F6A92D',
    },
  },
  // polygon outline stroke when in active
  {
    id: 'gl-draw-polygon-stroke-inactive',
    type: 'line',
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'false']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#62D6EF',
      'line-width': 2,
    },
  },
  // polygon outline stroke when active
  {
    id: 'gl-draw-polygon-stroke-active',
    type: 'line',
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'true']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#F6A92D',
      'line-dasharray': [0.2, 2],
      'line-width': 2,
    },
  },
  // vertex point halos
  {
    id: 'gl-draw-polygon-and-line-vertex-halo-active',
    type: 'circle',
    filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
    paint: {
      'circle-radius': 5,
      'circle-color': '#FFF',
    },
  },
  // vertex points
  {
    id: 'gl-draw-polygon-and-line-vertex-active',
    type: 'circle',
    filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
    paint: {
      'circle-radius': 3,
      'circle-color': '#F6A92D',
    },
  },
];
